import { useEffect } from "react";

const PLAUSIBLE_DOMAIN = process.env.REACT_APP_PLAUSIBLE_DOMAIN;

export default function Analytics() {
  useEffect(() => {
    if (!PLAUSIBLE_DOMAIN || document.querySelector('script[data-domain]')) return;

    const script = document.createElement("script");
    script.defer = true;
    script.dataset.domain = PLAUSIBLE_DOMAIN;
    script.src = "https://plausible.io/js/script.js";
    document.head.appendChild(script);
  }, []);

  return null;
}